import { useState, createContext, useContext, useEffect, useRef } from 'react';

interface CouponCodeContextInterface {
  referralCode: string | null;
  couponCode: string | null;
  setReferralCode: (value: string | null) => void;
  setCouponCode: (value: string | null) => void;
}

const CouponCodeContext = createContext<CouponCodeContextInterface>({
  referralCode: null,
  couponCode: null,
  setReferralCode: () => {},
  setCouponCode: () => {},
});

// Module-level ref to hold reset function
let resetCouponCodeRef: (() => void) | null = null;

export const resetCouponCodeContext = () => {
  if (resetCouponCodeRef) {
    resetCouponCodeRef();
  }
};

export const CouponCodeProvider = ({ children }) => {
  const params = new URLSearchParams(window.location.search);
  const [referralCode, setReferralCode] = useState<string | null>(null);
  const [couponCode, setCouponCode] = useState<string | null>(null);

  // Register reset function
  useEffect(() => {
    resetCouponCodeRef = () => {
      setReferralCode(null);
      setCouponCode(null);
    };
    return () => {
      resetCouponCodeRef = null;
    };
  }, []);

  useEffect(() => {
    const urlReferralCode = params.get('referralCode');
    const urlCouponCode = params.get('couponCode');

    if (urlReferralCode) setReferralCode(urlReferralCode);
    if (urlCouponCode) setCouponCode(urlCouponCode);
  }, []);

  return (
    <CouponCodeContext.Provider
      value={{
        referralCode,
        couponCode,
        setReferralCode,
        setCouponCode,
      }}
    >
      {children}
    </CouponCodeContext.Provider>
  );
};

export const useCouponCode = (): CouponCodeContextInterface => useContext(CouponCodeContext);

export default CouponCodeContext;
